import { useParams } from 'react-router'

import { READ_ONLY_WORKSPACE } from './constants'

export const useWorkspaceName = () => {
  const { workspaceName } = useParams<{ workspaceName: string }>()

  return workspaceName && workspaceName !== READ_ONLY_WORKSPACE
    ? workspaceName
    : undefined
}
